(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("schedulerpro", [], factory);
	else if(typeof exports === 'object')
		exports["schedulerpro"] = factory();
	else
		root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["schedulerpro"] = factory();
})(window, function() {
return 